import { round } from 'lodash';

const now = () => {
  return performance.now() ?? Date.now();
};

/**
 * A dev utility function to console.log the time between calls.
 *
 * @example
 * ```ts
 * const log = createTimeLogger('my-logger');
 * log('first');
 * log('second');
 * log('third');
 * ```
 **/
export function createTimeLogger(key: string): (part: string) => void {
  const before = now();
  const roundTime = (time: number) => round(time, 3);
  console.log(key, `start (@${roundTime(before)})`);
  let latest = before;

  return (part) => {
    const after = now();
    console.log(key, `${part} (@${roundTime(after)})`, roundTime(after - latest), roundTime(after - before));
    latest = after;
  };
}
